import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import * as auth from '../services/auth.js';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') ?? '');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);

    if (password !== confirm) {
      setError("Passwords don't match.");
      return;
    }
    if (password.length < 10) {
      setError('Password must be at least 10 characters.');
      return;
    }

    setLoading(true);
    try {
      await auth.resetPassword(email.trim().toLowerCase(), code.trim(), password);
      setDone(true);
      setTimeout(() => navigate('/signin'), 2000);
    } catch (err) {
      setError(err.message || 'Reset failed. Check the code and try again.');
    } finally {
      setLoading(false);
    }
  }

  if (done) {
    return (
      <main className="container narrow">
        <section className="rise">
          <h1 className="display">Reset <em>complete.</em></h1>
          <p className="lede">Redirecting you to sign in…</p>
        </section>
      </main>
    );
  }

  return (
    <main className="container narrow">
      <section className="rise">
        <h1 className="display">New <em>password</em></h1>
        <p className="lede">Enter the code we sent and choose something memorable.</p>

        <form onSubmit={onSubmit} className="card stack">
          <label className="field">
            <span className="field-label">Email</span>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label className="field">
            <span className="field-label">Recovery code</span>
            <input
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              required
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="6-digit code"
            />
          </label>

          <label className="field">
            <span className="field-label">New password</span>
            <input
              type="password"
              autoComplete="new-password"
              required
              minLength={10}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span className="field-hint">At least 10 characters, with an upper case, lower case, and number.</span>
          </label>

          <label className="field">
            <span className="field-label">Confirm password</span>
            <input
              type="password"
              autoComplete="new-password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
          </label>

          {error && <p className="error">{error}</p>}

          <div className="row between">
            <Link to="/signin" className="muted-link">Back to sign in</Link>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Resetting…' : 'Reset password'}
            </button>
          </div>
        </form>
      </section>
    </main>
  );
}
